var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_vm._v(" "),_c('side-bar',{attrs:{"logo":_vm.logo,"app-name":_vm.appName}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Inicio',
          path: _vm.$router.resolve({name:'dashboard'}).href,
          icon: 'fas fa-home',
        }}}),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('data_bases.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('data_bases.hi.data_bases'),
          path: _vm.$router.resolve({ name: 'dataBasesList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('convenios_ccaa.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('convenios_ccaa.hi.convenios'),
          path: _vm.$router.resolve({ name: 'conveniosCCAAList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('forum:categories.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('forum.hi.forum'),
          path: _vm.$router.resolve({ name: 'forumList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(
          _vm.is('Superadmin') ||
          _vm.can('additional_information:categories.view.all')
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('additional_information.hi.additional_information'),
          path: _vm.$router.resolve({ name: 'additionalInformationList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('circulars.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('circulars.hi.circulars'),
          path: _vm.$router.resolve({ name: 'circularsList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('value_added_services.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('value_added_services.hi.value_added_services'),
          path: _vm.$router.resolve({ name: 'valueAddedServicesList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('specific_services.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('specific_services.hi.specific_services'),
          path: _vm.$router.resolve({ name: 'specificServicesList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('utilities.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('utilities.hi.utilities'),
          path: _vm.$router.resolve({ name: 'utilitiesList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('agreements.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('agreements.hi.agreements'),
          path: _vm.$router.resolve({ name: 'agreementsList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('entrepreneurships.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('entrepreneurships.hi.entrepreneurships'),
          path: _vm.$router.resolve({ name: 'entrepreneurshipsList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('software_services.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('software_services.hi.software_services'),
          path: _vm.$router.resolve({ name: 'softwareServicesList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(
          _vm.is('Superadmin') ||
          _vm.can('internal_communications:categories.view.all')
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get(
            'internal_communications.hi.internal_communications'
          ),
          path: _vm.$router.resolve({ name: 'internalCommunicationsList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('process_management:view.all'))?_c('sidebar-item',{attrs:{"link":{
                name: _vm.trans.get('process_management.hi.process_management'),
                path: _vm.$router.resolve({name:'processManagementList'}).href,
                icon: 'fa fa-dot-circle'
            }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('library:categories.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('library.hi.library'),
          path: _vm.$router.resolve({ name: 'libraryList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('videos.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('videos.hi.videos'),
          path: _vm.$router.resolve({ name: 'videosList' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('offices.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('offices.hi.offices'),
          path: _vm.$router.resolve({ name: 'officesList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('professionals.view.all'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('professionals.hi.professionals'),
          path: _vm.$router.resolve({ name: 'professionalsList' }).href,
          icon: 'fas fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('professionals.manage.all'))?_c('sidebar-item',{attrs:{"link":{
                name: _vm.trans.get('professionals.hi.users'),
                path: _vm.$router.resolve({name:'usersList'}).href,
                icon: 'fas fa-dot-circle'
            }}}):_vm._e(),_vm._v(" "),(
          _vm.is('Superadmin') ||
          _vm.can('internal_support:messages.manage.create') ||
          _vm.can('internal_support:areas.manage.all')
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.trans.get('internal_support.hi.internal_support'),
          path: _vm.$router.resolve({ name: 'internalSuportMessageSend' }).href,
          icon: 'fa fa-dot-circle',
        }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('blog.manage.all'))?_c('sidebar-item',{attrs:{"link":{
                name: _vm.trans.get('blog.hi.blog'),
                path: _vm.$router.resolve({name:'blogPostsList'}).href,
                icon: 'fa fa-dot-circle'
            }}}):_vm._e(),_vm._v(" "),(_vm.is('Superadmin') || _vm.can('roles.manage.all'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.trans.get('roles.hi.roles'),
            path: _vm.$router.resolve({name:'rolesList'}).href,
            icon: 'fas fa-dot-circle'
            }}}):_vm._e()],1)],2),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),(_vm.$route.name !== 'dashboard' && _vm.$root.back != null)?_c('router-link',{ref:"goBack",staticClass:"btn btn-info btn-go-back-footer",attrs:{"to":_vm.$root.back,"title":_vm.trans.get('hi.go_back')}},[_c('i',{staticClass:"fas fa-reply"})]):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }